/**
 * Auth Module
 */
import Vue from 'vue'
import Nprogress from 'nprogress';
import router from '@/router';
import axios from 'axios';

// load api config in your site
import {API_ENDPOINT_URL, MASTER_API_KEY, ADMIN_LOGIN_URL} from '@/config/api_config'

const state = {
    token: null,
    user: [],
    userType: null,
    isLoggedin: false,
    permissions: []
}

// getters
const getters = {
    token: state => {
        return token
    },
    getUser: state => {
        return state.user;
    },
    isLoggedin: state => {
        return state.isLoggedin;
    },
    getUserType: state => {
        return state.user.type;
    },
    getPermission: state => {
      return state.permissions
    }
}

// actions
const actions = {
    signInUser(context, payload) {
        const { user } = payload;
        // clear user data
        context.commit('SET_AUTH_STATUS', false)
        context.commit('SET_USER', {});
        context.commit('loginUser');

        axios.post(`${API_ENDPOINT_URL}auth`,{
            access_token :MASTER_API_KEY
        },{
           auth: {
               username: user.email,
               password: user.password
           }
        }).then((res) => {
            Nprogress.done();
            const { data } = res

            context.commit('SET_AUTH_STATUS', true)

            let user_obj = {
                id: data.user.id,
                role: data.user.role,
                rolename: data.user.roleName,
                firstname: data.user.firstname,
                lastname: data.user.lastname,
                fullname: data.user.firstname + ' ' + data.user.lastname,
                email: data.user.email,
                type: data.user.authType || 'normal_auth'
            };

            // return department when logged in user from ad authen
            if (typeof data.user.department !== 'undefined') {
                user_obj.department = typeof data.user.department !== 'undefined' ? data.user.department : '';
            }
            const permissions = data.permissions ? JSON.stringify(data.permissions) : []

            localStorage.setItem('user',JSON.stringify(user_obj));
            localStorage.setItem('token', data.token);
            localStorage.setItem('permissions', permissions);
            
            context.commit('SET_PERMISSION', data.permissions);
            context.commit('SET_USER', user_obj);

            setTimeout(() => {
                context.commit('loginUserSuccess', user_obj);
                context.commit('setUserToken', data.token);
            }, 500)

        }).catch((error) => {
            let error_data = error.response;

            if (error_data) {
                context.commit('SET_AUTH_STATUS', false)
                context.commit('loginUserFailure', error_data);
            }
            Nprogress.done();
            
        });
    },
    logoutUser(context) {
        Nprogress.start();
        context.commit('logoutUser');
        Nprogress.done();
    }
}

// mutations
const mutations = {
    SET_USER(state, user) {
      state.user = user
    },
    SET_PERMISSION(state, permissions) {
      state.permissions = permissions
    },
    SET_AUTH_STATUS(state, status) {
       state.isLoggedin = status
    },
    loginUser(state) {
        Nprogress.start();
    },
    loginUserSuccess(state, response) {
        let { type } = response;

        state.user = response;
        if (typeof type !== 'undefined') {
            state.userType = type;
        }
        router.push("/admin/dashboard");

        setTimeout(function(){
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: 'User Logged In Success!'
            });
       },1500);
    },
    loginUserFailure(state, error) {
        state.user = null;
        state.userType = null;
        state.token = null;

        let message ='';
        if (error.status == 401) {
            message = 'Username or Password is wrong!';
        } else {
            message = error.data.message;
        }

        Vue.notify({
            group: 'loggedIn',
            type: 'error',
            text: message
        });
    },
    setUserToken(state, response) {
        state.token = response;
    },
    logoutUser(state) {
        state.user = null
        state.userType = null
        state.token = null
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('permissions');
        localStorage.removeItem('site');
        // localStorage.removeItem('vuex');

        router.push(ADMIN_LOGIN_URL);
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
